import React from 'react'

import ServiceOrdersControlBar from './ServiceOrdersControlBar'
import ServiceOrdersCounterBar from './ServiceOrdersCounterBar'
import CleanFilterButton from '../../../../components/filter/CleanFilterButton'

const PageHeader = () => {
  return (
    <>
      <ServiceOrdersControlBar />
      <ServiceOrdersCounterBar />
    </>
  )
}

export default PageHeader
